var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M528 304H480V112C480 67.887 444.111 32 400 32H80C35.889 32 0 67.887 0 112V160C0 186.508 21.49 208 48 208H80V160H48V112C48 94.375 62.375 80 80 80S112 94.375 112 112V400C112 444.113 147.889 480 192 480H458.625C523.346 480 576 427.348 576 362.625V352C576 325.492 554.51 304 528 304ZM224 336V400C224 417.625 209.625 432 192 432S160 417.625 160 400V112C160 100.609 157.527 89.816 153.219 80H400C417.6 80 432 94.398 432 112V304H256C238.326 304 224 318.328 224 336ZM528 362.625C528 400.875 496.875 432 458.625 432H265.219C269.527 422.184 272 411.391 272 400V352H528V362.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.0f7b274f4676d94ea5b280848881756a.svg";
export { ForwardRef as ReactComponent };